export type Lang = { code: string; name: string };

const SUPPORTED_URL = '/api/translations/supported_languages';
const STORAGE_KEY = 'app_language';

export async function fetchSupportedLanguages(): Promise<Lang[]> {
  const res = await fetch(SUPPORTED_URL);
  if (!res.ok) throw new Error('Failed to fetch supported languages');
  return res.json();
}

export function getSavedLanguage(): string | null {
  const item = localStorage.getItem(STORAGE_KEY);
  return item ? JSON.parse(item) : null;
  // FIXME: roll back when Yann's hook is available for use in specific widgets
  // if (!item) {
  //   return null;
  // }

  // const raw = item.trim();
  // if (!raw) {
  //   return null;
  // }

  // try {
  //   const parsed = JSON.parse(raw);
  //   return typeof parsed === 'string' && parsed ? parsed : null;
  // } catch {
  //   // Backward/interop support when the value is stored as plain text.
  //   return raw;
  // }
}

export function saveLanguage(code: string) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(code));
}

export function chooseInitialLanguage(supported: Lang[]): string {
  // use saved language if found
  const saved = getSavedLanguage();
  if (saved && supported.some((s) => s.code === saved)) return saved;

  // otherwise, use the browser's prefered language if supported
  const navLangs =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language];
  for (const l of navLangs) {
    const lower = (l ?? '').toLowerCase();
    // look up exact match
    const exact = supported.find((s) => s.code.toLowerCase() === lower);
    if (exact) return exact.code;
    // fallback to partial match (the language but not the country) if present
    const langOnly = lower.split('-')[0];
    const partial = supported.find((s) =>
      s.code.toLowerCase().startsWith(langOnly)
    );
    if (partial) return partial.code;
  }
  // default to French if all else fail
  return 'fr-FR';
}
